import Joi from 'joi'

import { EntityConstants } from 'constants/EntityConstants'
import { DecimalPattern } from 'constants/RegExConstants'


const YourBookingBidFormSchema = Joi.object({
  price: Joi.string().required().pattern(new RegExp(DecimalPattern)).messages({
    'string.base': 'Mandatory field',
    'string.empty': 'Mandatory field',
    'string.pattern.base': 'Only digits are allowed',
  }),
  currencyId: Joi.string().required().messages({
    'any.required': 'Mandatory field',
  }),
  vehicleId: Joi.string().required().messages({
    'any.required': 'Mandatory field',
  }),
  driverId: Joi.string().required().messages({
    'any.required': 'Mandatory field',
  }),
  eta: Joi.date().optional().allow(null),
  notes: Joi.string().max(EntityConstants.MAX_NUM_CHARACTERS_LENGTH).optional().allow(''),
})

export default YourBookingBidFormSchema
